/**
 * TERRAIN — Personalized Quiz JS
 * 6-step quiz: Postal code → Sunlight → Condition → Area → Email → Result
 * Scoring engine, Klaviyo API, Shopify Cart API, sticky ATC bar.
 * No dependencies. Loaded with defer.
 */
(function () {
  'use strict';

  /* ======== CONSTANTS ======== */
  var PRODUCT_ORDER = ['ombre', 'soleil', 'aride', 'vivant', 'prairie', 'regain'];
  var AUTO_ADVANCE_MS = 400;

  /* Scoring weights — sunlight × product (index matches PRODUCT_ORDER) */
  var SUNLIGHT_W = {
    full:    [0, 5, 2, 0, 0, 0],
    partial: [3, 1, 0, 2, 0, 0],
    shade:   [5, 0, 0, 2, 0, 0]
  };

  /* Area calculator — bucket presets (FR only) */
  var AREA_BUCKETS = [
    { id: 'xs', label: 'Moins de 50 m\u00b2', midpoint: 35, ref: 'Terrain de p\u00e9tanque' },
    { id: 's',  label: '50\u2013150 m\u00b2', midpoint: 100, ref: '\u00bd terrain de tennis' },
    { id: 'm',  label: '150\u2013400 m\u00b2', midpoint: 275, ref: 'Terrain de tennis' },
    { id: 'l',  label: '400\u20131 000 m\u00b2', midpoint: 700, ref: '5 cases de stationnement' },
    { id: 'xl', label: 'Plus de 1 000 m\u00b2', midpoint: 1250, ref: 'Entrer la mesure exacte' },
    { id: 'exact', label: 'Mesure exacte', midpoint: 0, ref: 'm\u00b2 ou pi\u00b2' }
  ];

  /* Scoring weights — condition × product */
  var CONDITION_W = {
    'new':       [0, 0, 0, 0, 0, 0],
    repair:      [0, 0, 0, 0, 0, 5],
    improve:     [0, 0, 0, 2, 2, 0],
    ecological:  [0, 0, 0, 5, 3, 0]
  };

  /* ======== LOAD DATA ======== */
  var zoneDataEl = document.getElementById('trn-zone-map');
  if (!zoneDataEl) return;

  var DATA;
  try {
    DATA = JSON.parse(zoneDataEl.textContent);
  } catch (e) {
    console.error('[TERRAIN Quiz] Zone data parse error:', e);
    return;
  }

  /* Load product blocks */
  var productBlocks = document.querySelectorAll('[data-product-block]');
  var PRODUCTS = {};
  productBlocks.forEach(function (el) {
    var slug = el.getAttribute('data-slug');
    if (slug) {
      PRODUCTS[slug] = {
        variantId: el.getAttribute('data-variant-id') || '',
        title: el.getAttribute('data-product-title') || slug.toUpperCase(),
        price: el.getAttribute('data-product-price') || '',
        url: el.getAttribute('data-product-url') || '#',
        image: el.getAttribute('data-product-image') || '',
        pitch: el.getAttribute('data-product-pitch') || '',
        variant_1_5kg: el.getAttribute('data-variant-1-5kg') || '',
        variant_5kg: el.getAttribute('data-variant-5kg') || '',
        variant_25kg: el.getAttribute('data-variant-25kg') || '',
        price_1_5kg: el.getAttribute('data-price-1-5kg') || '',
        price_5kg: el.getAttribute('data-price-5kg') || '',
        price_25kg: el.getAttribute('data-price-25kg') || '',
        coverage_new: parseFloat(el.getAttribute('data-coverage-new')) || 35
      };
    }
  });

  /* ======== DOM REFERENCES ======== */
  var section = document.getElementById('trn-quiz');
  if (!section) return;

  var progressBar = section.querySelector('[role="progressbar"]');
  var progressFill = section.querySelector('[data-quiz-progress-fill]');
  var progressText = section.querySelector('[data-quiz-progress-text]');
  var progressDots = section.querySelectorAll('[data-quiz-dot]');
  var progressConnectors = section.querySelectorAll('[data-quiz-connector]');
  var calcEl = section.querySelector('[data-quiz-calc]');
  var steps = section.querySelectorAll('[data-quiz-step]');

  /* Step 1 */
  var postcodeInput = section.querySelector('[data-quiz-postcode]');
  var postcodeSubmit = section.querySelector('[data-quiz-postcode-submit]');
  var errorEl = section.querySelector('[data-quiz-error]');
  var regionCard = section.querySelector('[data-quiz-region]');
  var regionName = section.querySelector('[data-quiz-region-name]');
  var regionHardiness = section.querySelector('[data-quiz-region-hardiness]');
  var regionSoil = section.querySelector('[data-quiz-region-soil]');
  var regionFrost = section.querySelector('[data-quiz-region-frost]');
  var regionSeeding = section.querySelector('[data-quiz-region-seeding]');
  var nextBtn = section.querySelector('[data-quiz-next]');

  /* Step 4 — Area */
  var calcBuckets = section.querySelector('[data-quiz-calc-buckets]');
  var calcExact = section.querySelector('[data-quiz-calc-exact]');
  var calcInput = section.querySelector('[data-quiz-calc-input]');
  var calcUnit = section.querySelector('[data-quiz-calc-unit]');
  var areaNextBtn = section.querySelector('[data-quiz-area-next]');

  /* Step 5 — Email */
  var emailInput = section.querySelector('[data-quiz-email]');
  var consentCheck = section.querySelector('[data-quiz-consent]');
  var emailSubmit = section.querySelector('[data-quiz-email-submit]');
  var emailError = section.querySelector('[data-quiz-email-error]');
  var skipBtn = section.querySelector('[data-quiz-skip]');

  /* Step 6 — Result */
  var resultImgWrap = section.querySelector('[data-quiz-result-img-wrap]');
  var resultImg = section.querySelector('[data-quiz-result-img]');
  var resultEyebrow = section.querySelector('[data-quiz-result-eyebrow]');
  var resultName = section.querySelector('[data-quiz-result-name]');
  var resultPitch = section.querySelector('[data-quiz-result-pitch]');
  var resultSeeding = section.querySelector('[data-quiz-result-seeding]');
  var resultAtc = section.querySelector('[data-quiz-result-atc]');
  var bagsOutput = section.querySelector('[data-quiz-bags-output]');

  /* Sticky bar */
  var stickyBar = section.querySelector('[data-quiz-sticky]');
  var stickyName = section.querySelector('[data-quiz-sticky-name]');
  var stickyPrice = section.querySelector('[data-quiz-sticky-price]');
  var stickyAtc = section.querySelector('[data-quiz-sticky-atc]');
  var stickyImg = section.querySelector('[data-quiz-sticky-img]');

  /* Retake */
  var retakeBtn = section.querySelector('[data-quiz-retake]');

  /* ======== STATE ======== */
  var state = {
    step: 1,
    postalCode: '',
    fsa: '',
    zoneId: '',
    zone: null,
    sunlight: '',
    condition: '',
    areaSqm: 0,
    email: '',
    recommended: ''
  };

  var atcBaseText = resultAtc ? resultAtc.textContent.trim() : 'Ajouter au panier';

  /* Email gate toggle — read from section data attribute */
  var emailGateEnabled = section.getAttribute('data-email-gate') === 'true';
  var totalSteps = emailGateEnabled ? 6 : 5;
  /* Result step is always step 6 in HTML */
  var resultStep = 6;

  /* ======== STEP NAVIGATION ======== */
  function goToStep(n) {
    state.step = n;

    steps.forEach(function (s) {
      var stepN = parseInt(s.getAttribute('data-quiz-step'), 10);
      if (stepN === n) {
        s.removeAttribute('hidden');
        s.classList.add('trn-quiz__step--active');
        /* Focus first heading for a11y */
        var heading = s.querySelector('.trn-quiz__step-title');
        if (heading) {
          heading.setAttribute('tabindex', '-1');
          heading.focus({ preventScroll: true });
        }
      } else {
        s.setAttribute('hidden', '');
        s.classList.remove('trn-quiz__step--active');
      }
    });

    /* Update progress dots */
    progressDots.forEach(function (dot) {
      var dotN = parseInt(dot.getAttribute('data-quiz-dot'), 10);
      dot.classList.remove('trn-quiz__progress-dot--active', 'trn-quiz__progress-dot--complete');
      if (dotN === n) {
        dot.classList.add('trn-quiz__progress-dot--active');
      } else if (dotN < n) {
        dot.classList.add('trn-quiz__progress-dot--complete');
      }
    });
    progressConnectors.forEach(function (conn) {
      var connN = parseInt(conn.getAttribute('data-quiz-connector'), 10);
      conn.style.transform = connN < n ? 'scaleX(1)' : 'scaleX(0)';
    });

    /* Update progress text + ARIA */
    /* Map step number to display number (skip email step 5 if not enabled) */
    var displayStep = n;
    if (!emailGateEnabled && n === resultStep) displayStep = totalSteps;
    displayStep = Math.min(displayStep, totalSteps);
    if (progressText) progressText.textContent = displayStep + ' / ' + totalSteps;
    if (progressBar) progressBar.setAttribute('aria-valuenow', displayStep);

    /* Scroll quiz into view */
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });

    /* Analytics */
    fireAnalytics('quiz_step', { step: n });
  }

  /* ======== STEP 1: POSTAL CODE ======== */

  /* Auto-format: add space after 3rd char, uppercase */
  if (postcodeInput) {
    postcodeInput.addEventListener('input', function () {
      var v = postcodeInput.value.replace(/\s/g, '').toUpperCase().slice(0, 6);
      if (v.length > 3) {
        postcodeInput.value = v.slice(0, 3) + ' ' + v.slice(3);
      } else {
        postcodeInput.value = v;
      }
    });

    postcodeInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        validatePostcode();
      }
    });
  }

  if (postcodeSubmit) {
    postcodeSubmit.addEventListener('click', function (e) {
      e.preventDefault();
      validatePostcode();
    });
  }

  function validatePostcode() {
    if (!postcodeInput) return;
    var raw = postcodeInput.value.replace(/\s/g, '').toUpperCase();

    if (!/^[A-Z]\d[A-Z]\d[A-Z]\d$/.test(raw)) {
      showMsg(errorEl, 'error', getSettingText('error_invalid', 'Entrez un code postal valide (ex.\u00a0: J2K 3B4).'));
      fireAnalytics('quiz_postcode', { result: 'invalid' });
      return;
    }

    state.postalCode = raw;
    state.fsa = raw.substring(0, 3);

    /* Zone lookup — try 3-char, 2-char, 1-char prefix */
    var zoneId = DATA.fsa[state.fsa]
      || DATA.fsa[state.fsa.substring(0, 2)]
      || DATA.fsa[state.fsa.charAt(0)]
      || null;

    if (!zoneId || !DATA.zones[zoneId]) {
      showMsg(errorEl, 'error', getSettingText('error_province', 'TERRAIN n\u2019est disponible qu\u2019au Qu\u00e9bec pour le moment.'));
      fireAnalytics('quiz_postcode', { result: 'out_of_province', fsa: state.fsa });
      return;
    }

    state.zoneId = zoneId;
    state.zone = DATA.zones[zoneId];

    /* Clear error */
    showMsg(errorEl, '', '');

    /* Populate region card */
    if (regionName) regionName.textContent = state.zone.name;
    if (regionHardiness) regionHardiness.textContent = state.zone.hardiness;
    if (regionSoil) regionSoil.textContent = state.zone.soil;
    if (regionFrost) regionFrost.textContent = state.zone.frost;
    if (regionSeeding) regionSeeding.textContent = state.zone.seeding;
    if (regionCard) regionCard.removeAttribute('hidden');

    fireAnalytics('quiz_postcode', { result: 'valid', fsa: state.fsa, zone: zoneId });
  }

  /* Next button on region card → go to step 2 */
  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      if (state.zoneId) goToStep(2);
    });
  }

  /* ======== STEPS 2 & 3: OPTION SELECTION ======== */
  var optionBtns = section.querySelectorAll('[data-quiz-option]');
  optionBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.getAttribute('data-quiz-option');
      var value = btn.getAttribute('data-value');

      /* Toggle selection within group */
      var siblings = section.querySelectorAll('[data-quiz-option="' + group + '"]');
      siblings.forEach(function (s) {
        s.setAttribute('aria-checked', 'false');
        s.classList.remove('trn-quiz__option--selected');
      });
      btn.setAttribute('aria-checked', 'true');
      btn.classList.add('trn-quiz__option--selected');

      /* Update state */
      state[group] = value;
      fireAnalytics('quiz_option', { group: group, value: value });

      /* Auto-advance after delay */
      setTimeout(function () {
        if (group === 'sunlight') {
          goToStep(3);
        } else if (group === 'condition') {
          /* Calculate recommendation, then go to area step */
          state.recommended = calculateRecommendation();
          goToStep(4);
          renderAreaCalculator();
        }
      }, AUTO_ADVANCE_MS);
    });

    /* Keyboard: arrow keys within radiogroup */
    btn.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' &&
          e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;

      e.preventDefault();
      var group = btn.getAttribute('data-quiz-option');
      var siblings = Array.prototype.slice.call(
        section.querySelectorAll('[data-quiz-option="' + group + '"]')
      );
      var idx = siblings.indexOf(btn);
      var next = (e.key === 'ArrowDown' || e.key === 'ArrowRight')
        ? (idx + 1) % siblings.length
        : (idx - 1 + siblings.length) % siblings.length;
      siblings[next].focus();
    });
  });

  /* ======== SCORING ENGINE ======== */
  function calculateRecommendation() {
    var scores = [];
    var zoneWeights = (state.zone && state.zone.weights) || [0, 0, 0, 0, 0, 0];
    var sunWeights = SUNLIGHT_W[state.sunlight] || [0, 0, 0, 0, 0, 0];
    var condWeights = CONDITION_W[state.condition] || [0, 0, 0, 0, 0, 0];

    for (var i = 0; i < PRODUCT_ORDER.length; i++) {
      scores.push({
        slug: PRODUCT_ORDER[i],
        score: zoneWeights[i] + sunWeights[i] + condWeights[i]
      });
    }

    /* Sort by score descending, tie-break by canonical order (array index) */
    scores.sort(function (a, b) {
      if (b.score !== a.score) return b.score - a.score;
      return PRODUCT_ORDER.indexOf(a.slug) - PRODUCT_ORDER.indexOf(b.slug);
    });

    return scores[0].slug;
  }

  /* ======== STEP 4: EMAIL GATE ======== */
  if (emailSubmit) {
    emailSubmit.addEventListener('click', function () {
      submitEmail();
    });
  }

  if (emailInput) {
    emailInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        submitEmail();
      }
    });
  }

  if (skipBtn) {
    skipBtn.addEventListener('click', function () {
      fireAnalytics('quiz_email', { action: 'skipped' });
      showResult();
    });
  }

  function submitEmail() {
    if (!emailInput) return;
    var email = emailInput.value.trim();

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      showMsg(emailError, 'error', 'Entrez une adresse courriel valide.');
      return;
    }

    if (consentCheck && !consentCheck.checked) {
      showMsg(emailError, 'error', 'Veuillez accepter les communications pour continuer.');
      return;
    }

    state.email = email;
    showMsg(emailError, '', '');

    /* Disable button during submit */
    emailSubmit.disabled = true;
    emailSubmit.textContent = 'Envoi\u2026';

    submitToKlaviyo(email, function () {
      showResult();
    });
  }

  /* ======== KLAVIYO API ======== */
  function submitToKlaviyo(email, callback) {
    var listId = DATA.klaviyo_list;
    if (!listId) {
      fireAnalytics('quiz_email', { action: 'no_list_id' });
      callback();
      return;
    }

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'TERRAIN Quiz',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: {
                  terrain_recommendation: state.recommended,
                  terrain_zone: state.zoneId,
                  terrain_zone_name: state.zone ? state.zone.name : '',
                  terrain_sunlight: state.sunlight,
                  terrain_condition: state.condition,
                  terrain_fsa: state.fsa
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId
            }
          }
        }
      }
    };

    var companyId = DATA.klaviyo_company;
    if (!companyId) {
      console.warn('[TERRAIN Quiz] No Klaviyo company ID configured.');
      fireAnalytics('quiz_email', { action: 'no_company_id' });
      callback();
      return;
    }

    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 10000);

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify(payload),
      signal: controller.signal
    })
    .then(function () {
      fireAnalytics('quiz_email', { action: 'subscribed', email_domain: email.split('@')[1] });
    })
    .catch(function (err) {
      /* Silently fail — email is a bonus, not a blocker */
      console.warn('[TERRAIN Quiz] Klaviyo error:', err.message);
      fireAnalytics('quiz_email', { action: 'error' });
    })
    .finally(function () {
      clearTimeout(timeout);
      callback();
    });
  }

  /* ======== STEP 4: AREA — continue button ======== */
  if (areaNextBtn) {
    areaNextBtn.addEventListener('click', function () {
      if (state.areaSqm > 0) {
        if (emailGateEnabled) {
          goToStep(5);
        } else {
          showResult();
        }
      }
    });
  }

  /* ======== STEP 6: RESULT ======== */
  function showResult() {
    var slug = state.recommended;
    var product = PRODUCTS[slug];

    if (!product) {
      console.error('[TERRAIN Quiz] No product data for slug:', slug);
      return;
    }

    /* Populate result panel */
    if (resultName) resultName.textContent = product.title;
    if (resultPitch) resultPitch.textContent = product.pitch;
    if (resultSeeding && state.zone) {
      resultSeeding.textContent = 'Semez entre le ' + state.zone.seeding + ' dans votre r\u00e9gion.';
    }

    /* Product image */
    if (resultImg && product.image) {
      resultImg.src = product.image;
      resultImg.alt = 'M\u00e9lange TERRAIN ' + product.title;
      resultImg.style.display = '';
      if (resultImgWrap) resultImgWrap.classList.add('trn-quiz__result-image--has-img');
    }

    /* ATC button */
    if (resultAtc) {
      resultAtc.setAttribute('data-variant-id', product.variantId);
      resultAtc.textContent = product.price
        ? atcBaseText + ' \u2014 ' + product.price
        : atcBaseText;
      resultAtc.disabled = !product.variantId;
    }

    /* Sticky bar */
    if (stickyName) stickyName.textContent = 'M\u00e9lange ' + product.title;
    if (stickyPrice) stickyPrice.textContent = product.price;
    if (stickyAtc) {
      stickyAtc.setAttribute('data-variant-id', product.variantId);
      stickyAtc.disabled = !product.variantId;
    }

    /* Sticky bar thumbnail */
    if (stickyImg && product.image) {
      stickyImg.src = product.image;
      stickyImg.alt = 'M\u00e9lange TERRAIN ' + product.title;
      stickyImg.style.display = '';
    }

    /* Result link */
    var resultAll = section.querySelector('[data-quiz-result-all]');
    if (resultAll && product.url && product.url !== '#') {
      /* Keep the "all products" link as-is, it goes to collection */
    }

    /* Calculation animation — show spinner for 1.8s, then reveal result */
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var calcDelay = (calcEl && !reducedMotion) ? 1800 : 0;

    if (calcEl && !reducedMotion) {
      /* Hide all steps during calc */
      steps.forEach(function (s) {
        s.setAttribute('hidden', '');
        s.classList.remove('trn-quiz__step--active');
      });
      calcEl.removeAttribute('hidden');
    }

    setTimeout(function () {
      if (calcEl) calcEl.setAttribute('hidden', '');
      goToStep(6);

      /* Calculate bags from step 4 area selection */
      if (state.areaSqm > 0) {
        calculateBags(state.areaSqm);
      }

      /* Init sticky bar after result is shown */
      setTimeout(initStickyAtc, 500);
    }, calcDelay);

    fireAnalytics('quiz_result', {
      product: slug,
      zone: state.zoneId,
      sunlight: state.sunlight,
      condition: state.condition
    });
  }

  /* ======== STEP 4: AREA CALCULATOR ======== */

  var currentUnit = 'm2';

  function convertToSqm(val) {
    if (currentUnit === 'ft2') return val * 0.0929;
    if (currentUnit === 'acres') return val * 4046.86;
    return val;
  }

  function setAreaSqm(sqm) {
    state.areaSqm = sqm;
    if (areaNextBtn) areaNextBtn.disabled = !(sqm > 0);
  }

  function renderAreaCalculator() {
    if (!calcBuckets) return;

    var html = '';
    AREA_BUCKETS.forEach(function (b) {
      html += '<button class="trn-quiz__calc-bucket" type="button" data-calc-bucket="' + b.id + '">'
        + '<div class="trn-quiz__calc-bucket-label">' + b.label + '</div>'
        + '<div class="trn-quiz__calc-bucket-ref">' + b.ref + '</div>'
        + '</button>';
    });
    calcBuckets.innerHTML = html;

    /* Bind bucket clicks */
    calcBuckets.querySelectorAll('[data-calc-bucket]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-calc-bucket');

        /* Deselect all */
        calcBuckets.querySelectorAll('.trn-quiz__calc-bucket').forEach(function (b) {
          b.classList.remove('trn-quiz__calc-bucket--selected');
        });
        btn.classList.add('trn-quiz__calc-bucket--selected');

        if (id === 'xl' || id === 'exact') {
          if (calcExact) calcExact.hidden = false;
          if (calcInput) calcInput.focus();
          /* Check if input already has a value */
          var val = parseFloat(calcInput ? calcInput.value : 0);
          if (val > 0) {
            setAreaSqm(convertToSqm(val));
          } else {
            setAreaSqm(0);
          }
        } else {
          if (calcExact) calcExact.hidden = true;
          var bucket = AREA_BUCKETS.find(function (b) { return b.id === id; });
          if (bucket) setAreaSqm(bucket.midpoint);
        }
      });
    });

    /* Exact input */
    if (calcInput) {
      calcInput.addEventListener('input', function () {
        var val = parseFloat(calcInput.value);
        if (val > 0) {
          setAreaSqm(convertToSqm(val));
        } else {
          setAreaSqm(0);
        }
      });
    }

    /* Unit toggle */
    if (calcUnit) {
      calcUnit.addEventListener('click', function () {
        if (currentUnit === 'm2') {
          currentUnit = 'ft2';
          calcUnit.textContent = 'pi\u00b2';
        } else if (currentUnit === 'ft2') {
          currentUnit = 'acres';
          calcUnit.textContent = 'acres';
        } else {
          currentUnit = 'm2';
          calcUnit.textContent = 'm\u00b2';
        }
        /* Recalculate if there's a value */
        var val = parseFloat(calcInput.value);
        if (val > 0) {
          setAreaSqm(convertToSqm(val));
        }
      });
    }

    /* Reset state */
    if (calcExact) calcExact.hidden = true;
    if (calcInput) calcInput.value = '';
    setAreaSqm(0);
  }

  /* ======== BAG SELECTION ALGORITHM ======== */

  function selectBags(kgNeeded) {
    var SIZES = [25, 5, 1.5];
    var remaining = kgNeeded;
    var result = {};
    for (var i = 0; i < SIZES.length; i++) {
      var count = Math.floor(remaining / SIZES[i]);
      if (count > 0) {
        result[SIZES[i]] = count;
        remaining -= count * SIZES[i];
      }
    }
    if (remaining > 0) {
      result[1.5] = (result[1.5] || 0) + 1;
    }
    return result;
  }

  function calculateBags(areaSqm) {
    var product = PRODUCTS[state.recommended];
    if (!product || !product.coverage_new || !bagsOutput) return;

    var kgNeeded = areaSqm / product.coverage_new;
    var bags = selectBags(kgNeeded);

    /* Build output */
    var totalKg = 0;
    var parts = [];
    var cartItems = [];

    if (bags[25]) {
      totalKg += bags[25] * 25;
      parts.push(bags[25] + ' \u00d7 25 kg');
      if (product.variant_25kg) cartItems.push({ id: product.variant_25kg, qty: bags[25] });
    }
    if (bags[5]) {
      totalKg += bags[5] * 5;
      parts.push(bags[5] + ' \u00d7 5 kg');
      if (product.variant_5kg) cartItems.push({ id: product.variant_5kg, qty: bags[5] });
    }
    if (bags[1.5]) {
      totalKg += bags[1.5] * 1.5;
      parts.push(bags[1.5] + ' \u00d7 1,5 kg');
      if (product.variant_1_5kg) cartItems.push({ id: product.variant_1_5kg, qty: bags[1.5] });
    }

    var headline = 'Pour ' + Math.round(areaSqm) + ' m\u00b2, vous avez besoin de ' + parts.join(' + ') + ' de ' + product.title + '.';
    var detail = 'Cela couvre votre surface compl\u00e8te (' + Math.round(totalKg * 10) / 10 + ' kg au total).';

    /* Calculate price */
    var totalPrice = 0;
    var hasPrice = false;
    if (bags[25] && product.price_25kg) { totalPrice += bags[25] * parseFloat(product.price_25kg); hasPrice = true; }
    if (bags[5] && product.price_5kg) { totalPrice += bags[5] * parseFloat(product.price_5kg); hasPrice = true; }
    if (bags[1.5] && product.price_1_5kg) { totalPrice += bags[1.5] * parseFloat(product.price_1_5kg); hasPrice = true; }

    var html = '<div class="trn-quiz__bags">'
      + '<p class="trn-quiz__bags-headline">' + headline + '</p>'
      + '<p class="trn-quiz__bags-detail">' + detail + '</p>';

    if (hasPrice) {
      html += '<p class="trn-quiz__bags-price">' + totalPrice.toFixed(2) + '$ + taxes</p>';
      if (totalPrice >= 75) {
        html += '<p class="trn-quiz__bags-delivery trn-quiz__bags-delivery--free">Livraison gratuite au Qu\u00e9bec incluse \u2713</p>';
      } else {
        var gap = (75 - totalPrice).toFixed(2);
        html += '<p class="trn-quiz__bags-delivery">Ajoutez ' + gap + '$ pour la livraison gratuite</p>';
      }
    }

    html += '</div>';
    bagsOutput.innerHTML = html;

    /* If we have multi-item cart data, replace the simple ATC with multi-item ATC */
    if (cartItems.length && resultAtc) {
      resultAtc.setAttribute('data-calc-cart-items', JSON.stringify(cartItems));
      resultAtc.textContent = 'Ajouter ' + parts.join(' + ') + ' au panier';
      resultAtc.disabled = false;
    }

    fireAnalytics('quiz_calculator', {
      product: state.recommended,
      area_sqm: Math.round(areaSqm),
      total_kg: Math.round(totalKg * 10) / 10,
      bags: parts.join(' + ')
    });
  }

  /* ======== MULTI-ITEM ADD TO CART ======== */

  function addMultipleToCart(items, btn) {
    var origText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Ajout en cours\u2026';

    var cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    var payload = {
      items: items.map(function (item) {
        return { id: parseInt(item.id, 10), quantity: item.qty };
      })
    };

    var controller = new AbortController();
    var timeoutId = setTimeout(function () { controller.abort(); }, 8000);

    fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload),
      signal: controller.signal
    })
    .then(function (response) {
      clearTimeout(timeoutId);
      if (!response.ok) {
        return response.json().catch(function () { return {}; }).then(function (d) {
          throw new Error(d.description || d.message || 'Erreur serveur');
        });
      }
      return response.json();
    })
    .then(function (data) {
      /* Update cart drawer */
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
        if (typeof cartDrawer.open === 'function') cartDrawer.open();
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        return;
      }

      btn.textContent = 'Ajout\u00e9 \u2713';
      btn.disabled = false;
      setTimeout(function () { btn.textContent = origText; }, 2000);

      fireAnalytics('quiz_calc_atc', { product: state.recommended, items: items.length });
    })
    .catch(function (err) {
      btn.disabled = false;
      btn.textContent = err.name === 'AbortError' ? 'D\u00e9lai d\u00e9pass\u00e9.' : (err.message || 'Erreur');
      setTimeout(function () { btn.textContent = origText; }, 3000);
    });
  }

  /* ======== ADD TO CART ======== */
  function bindAtc(btn) {
    if (!btn) return;
    btn.addEventListener('click', function () {
      /* Multi-item cart add (from calculator) takes priority */
      var cartItemsJson = btn.getAttribute('data-calc-cart-items');
      if (cartItemsJson) {
        try {
          var items = JSON.parse(cartItemsJson);
          if (items.length) { addMultipleToCart(items, btn); return; }
        } catch (e) { /* fall through to single-item */ }
      }
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      addToCart(variantId, btn);
    });
  }

  bindAtc(resultAtc);
  bindAtc(stickyAtc);

  function addToCart(variantId, btn) {
    var origText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Ajout en cours\u2026';

    var cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    /* Section rendering for cart drawer */
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      formData.append('sections', cartDrawer.getSectionsToRender().map(function (s) { return s.id; }));
      formData.append('sections_url', window.location.pathname);
      cartDrawer.setActiveElement(document.activeElement);
    }

    var controller = new AbortController();
    var timeoutId = setTimeout(function () { controller.abort(); }, 8000);

    fetch(cartAddUrl, {
      method: 'POST',
      body: formData,
      signal: controller.signal,
      headers: {
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(function (response) {
      clearTimeout(timeoutId);

      var ct = response.headers.get('content-type') || '';
      if (ct.includes('text/html')) {
        openCartFallback(cartDrawer);
        return null;
      }

      if (!response.ok) {
        return response.json().catch(function () { return {}; }).then(function (d) {
          throw new Error(d.description || d.message || 'Erreur serveur');
        });
      }
      return response.json();
    })
    .then(function (data) {
      if (!data) return;

      if (data.status && data.status !== 200) {
        throw new Error(data.description || data.message || 'Erreur');
      }

      /* Publish cart event */
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'terrain-quiz', productVariantId: variantId });
      }

      /* Update cart drawer */
      if (cartDrawer) {
        if (cartDrawer.classList.contains('is-empty')) {
          cartDrawer.classList.remove('is-empty');
        }
        if (typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(data);
        } else if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        return;
      }

      /* Success state */
      btn.textContent = 'Ajout\u00e9 \u2713';
      btn.disabled = false;
      setTimeout(function () { btn.textContent = origText; }, 2000);

      fireAnalytics('quiz_atc', { product: state.recommended, variant: variantId });
    })
    .catch(function (err) {
      btn.disabled = false;
      if (err.name === 'AbortError') {
        btn.textContent = 'D\u00e9lai d\u00e9pass\u00e9.';
      } else {
        btn.textContent = err.message || 'Erreur';
      }
      setTimeout(function () { btn.textContent = origText; }, 3000);
    });
  }

  function openCartFallback(cartDrawer) {
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    } else {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    }
  }

  /* ======== STICKY ATC BAR ======== */
  function initStickyAtc() {
    if (!stickyBar || !resultAtc || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      /* Show sticky bar when result ATC is NOT visible */
      var visible = entries[0].isIntersecting;
      if (!visible && state.step === 6) {
        stickyBar.removeAttribute('hidden');
        /* Allow reflow before adding visible class for CSS transition */
        requestAnimationFrame(function () {
          stickyBar.classList.add('trn-quiz__sticky--visible');
        });
      } else {
        stickyBar.classList.remove('trn-quiz__sticky--visible');
        /* Re-hide after transition completes */
        stickyBar.addEventListener('transitionend', function hideBar() {
          if (!stickyBar.classList.contains('trn-quiz__sticky--visible')) {
            stickyBar.setAttribute('hidden', '');
          }
          stickyBar.removeEventListener('transitionend', hideBar);
        });
      }
    }, { threshold: 0 });

    observer.observe(resultAtc);
  }

  /* ======== RETAKE ======== */
  if (retakeBtn) {
    retakeBtn.addEventListener('click', function () {
      /* Reset state */
      state.postalCode = '';
      state.fsa = '';
      state.zoneId = '';
      state.zone = null;
      state.sunlight = '';
      state.condition = '';
      state.email = '';
      state.recommended = '';

      /* Reset UI */
      if (postcodeInput) postcodeInput.value = '';
      if (regionCard) regionCard.setAttribute('hidden', '');
      showMsg(errorEl, '', '');
      showMsg(emailError, '', '');
      if (emailInput) emailInput.value = '';
      if (consentCheck) consentCheck.checked = false;
      if (emailSubmit) {
        emailSubmit.disabled = false;
        emailSubmit.textContent = emailSubmit.getAttribute('data-original-text') || 'Voir ma recommandation';
      }

      /* Reset option selections */
      optionBtns.forEach(function (btn) {
        btn.setAttribute('aria-checked', 'false');
        btn.classList.remove('trn-quiz__option--selected');
      });

      /* Hide sticky bar */
      if (stickyBar) {
        stickyBar.classList.remove('trn-quiz__sticky--visible');
        stickyBar.setAttribute('hidden', '');
      }

      /* Reset area step */
      state.areaSqm = 0;
      currentUnit = 'm2';
      if (calcBuckets) calcBuckets.innerHTML = '';
      if (calcExact) calcExact.hidden = true;
      if (calcInput) calcInput.value = '';
      if (calcUnit) calcUnit.textContent = 'm\u00b2';
      if (areaNextBtn) areaNextBtn.disabled = true;
      if (bagsOutput) bagsOutput.innerHTML = '';
      if (resultAtc) resultAtc.removeAttribute('data-calc-cart-items');

      goToStep(1);
      fireAnalytics('quiz_retake', {});
    });
  }

  /* ======== UTILITIES ======== */
  function showMsg(el, type, text) {
    if (!el) return;
    el.textContent = text;
    el.className = 'trn-quiz__msg' + (type ? ' trn-quiz__msg--' + type : '');
  }

  function getSettingText(key, fallback) {
    /* Read error messages exposed as data attributes on the section element */
    var attr = section.getAttribute('data-' + key.replace(/_/g, '-'));
    return attr || fallback;
  }

  function fireAnalytics(event, data) {
    if (window.dataLayer) {
      var payload = { event: 'terrain_' + event };
      for (var k in data) {
        if (data.hasOwnProperty(k)) payload[k] = data[k];
      }
      window.dataLayer.push(payload);
    }
  }

  /* ======== INIT ======== */
  /* Store original email button text for retake */
  if (emailSubmit) {
    emailSubmit.setAttribute('data-original-text', emailSubmit.textContent.trim());
  }

  /* Check for hash-based deep link */
  if (window.location.hash === '#trn-quiz') {
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ======== SCROLL REVEAL SYSTEM ======== */
  (function initReveal() {
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var reveals = document.querySelectorAll('.trn-reveal');

    if (!reveals.length) return;

    if (reducedMotion || !('IntersectionObserver' in window)) {
      /* Instant visible — no animation */
      reveals.forEach(function (el) { el.classList.add('trn-reveal--visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('trn-reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

    reveals.forEach(function (el) { observer.observe(el); });
  })();

})();
